<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <div>
      <div class="bodyCenter">
        <div class="modalStyle">
          <div class="titulos">
            <div class="seccionTitle">
              <b-icon icon="person-lines-fill" class="mLeft"></b-icon>
              <div class="headerTxt mLeft">
                Administración de autorizaciones
              </div>
            </div>
            <div class="seccionCodigo">
              Admin_autorizaciones
            </div>
          </div>
          <div class="buttonGenerar">
            <br />
            <b-button
              variant="primary"
              @click="abrirDetalleEmpty()"
              v-if="$localStorageService.can('AU_01_autorizacion_crear')"
            >
              Generar autorización
            </b-button>
          </div>

          <div class="flxDivs">
            <div class="div90">
              <b-skeleton-table
                :rows="5"
                :columns="12"
                :table-props="{ bordered: true, striped: true }"
                v-if="cargandoTabla == true"
              ></b-skeleton-table>
              <span v-if="arrayNiveles.length != 0">
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Buscar"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''"
                      >Limpiar
                      <!-- <em class="fa fa-trash"></em> -->
                    </b-button>
                  </b-input-group-append>
                </b-input-group>

                <b-table
                  empty-filtered-text="Sin resultados"
                  empty-text="No hay datos"
                  show-empty
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                  :busy="isBusy"
                  responsive
                  striped
                  hover
                  :items="arrayNiveles"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  v-if="arrayNiveles.length != 0 && cargandoTabla == false"
                  thead-tr-class="columnas"
                >
                  <template #cell(montoMinimo)="row">
                    {{ row.item.montoMinimo | moneda }}
                  </template>

                  <template #cell(montoMaximo)="row">
                    {{ row.item.montoMaximo | moneda }}
                  </template>
                  <template #cell(clinicas)="row">
                    <span
                      v-for="item in row.item.clinicas"
                      :key="item.idEmpleadoClinica"
                      style="text-align: left"
                    >
                      <b-badge
                        variant="info"
                        style="margin-left: 5px; text-align: left"
                        >{{ item.nombreClinica }}</b-badge
                      >
                    </span>
                  </template>


<!--                  <template #cell(tiposMovimiento)="row">
                    <span
                        v-for="item in row.item.tiposMovimiento"
                        :key="item.idTipoMovimiento"
                        style="text-align: left"
                    >
                      <b-badge
                          variant="warning"
                          style="margin-left: 5px; text-align: left"
                      >{{ item.descripcion }}</b-badge> <br>
                    </span>
                  </template>-->

                  <template v-slot:cell(registroActivo)="row">
                    <span v-if="row.item.registroActivo == true">
                      <b-badge variant="success"
                        ><b-icon icon="check-square" font-scale="1.5"></b-icon
                      ></b-badge>
                    </span>
                    <span v-else>
                      <b-badge variant="warning"
                        ><b-icon icon="x-square" font-scale="1.5"></b-icon
                      ></b-badge>
                    </span>
                  </template>

                  <template #cell(Detalle)="row">
                    <b-button
                      variant="primary"
                      @click="abrirDetalle(row.item)"
                      v-if="
                        $localStorageService.can('AU_01_autorizacion_detalle')
                      "
                    >
                      <em class="fa fa-eye"></em>
                    </b-button>
                  </template>

                  <b-badge variant="warning">Warning</b-badge>
                </b-table>
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  align="center"
                  aria-controls="my-table1"
                ></b-pagination>
                <br />
                <br />
              </span>
              <strong v-if="arrayNiveles.length == 0 && cargandoTabla == false"
                >Sin registros</strong
              >
            </div>
          </div>
        </div>
      </div>
    </div>

<!--Inicio modal -->
    <b-modal id="modal-detalle" size="lg" hide-footer @hidden="resetModal">
      <template v-if="info.idNivel != null" #modal-title>AUTORIZACIÓN No. {{ info.idNivel }}</template>
      <template v-else #modal-title>NUEVA AUTORIZACIÓN</template>
      <div class="d-block text-left">
        <div class="flexDiv" v-if="info.nombreEmpleado != null">
          <p class="item80">
            <strong>Empleado: </strong>{{ info.nombreEmpleado }}
          </p>

          <b-button
            title="Eliminar registro"
            variant="danger"
            size="sm"
            class="item20"
            @click="(info.nombreEmpleado = null), (info.idEmpleado = null)"
          >
            <b-icon icon="trash-fill"></b-icon>
          </b-button>
        </div>

        <b-form-group label="Empleado" class="mginTop10" v-else>
          <span class="inputIconDiv">
            <v-select
              style="width: 100%"
              label="nombre"
              :filterable="false"
              :options="colaboradores"
              @search="getColaboradores"
              :reduce="(colaborador) => colaborador.id"
              v-model="info.idEmpleado"
              placeholder=""
            >
              <template slot="no-options">Sin datos</template>
            </v-select>

            <b-button variant="primary" disabled v-if="loadingColaboradores">
              <b-spinner small></b-spinner>
            </b-button>
          </span>
        </b-form-group>

        <b-row>
          <b-col cols="6">
            <b-form-group label="Monto Mínimo *" label-align="left" id="fieldset-1">
              <b-form-input
                  v-model.number="info.montoMinimo"
                  pattern="[0-9]{1,}"
                  type="number"
                  step="any"
                  @input="sinDecimales()"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Monto Máximo *" label-align="left" id="fieldset-2">
              <b-form-input
                  v-model.number="info.montoMaximo"
                  pattern="[0-9]{1,}"
                  type="number"
                  step="any"
                  @input="sinDecimales()"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-button v-if="!allSelected" variant="outline-primary" size="sm" class="mb-3" @click="seleccionarTodo">
          Seleccionar todos los tipos de movimiento
        </b-button>
        <b-button v-else variant="outline-danger" size="sm" class="mb-3" @click="deseleccionarTodo">
          Deseleccionar todos los tipos de movimiento
        </b-button>


        <b-tabs>
          <b-tab v-for="(movimiento, indice) in tiposMovimiento" :key="indice"
                 :title="movimiento.nombre"
          >
            <div class="m-3">
              <b-form-checkbox
                  v-for="option in movimiento.tiposMovimiento"
                  v-model="info.movimientos"
                  :key="option.value"
                  :value="option.value"

              >
                {{ option.text }}
              </b-form-checkbox>
            </div>
          </b-tab>
        </b-tabs>

        <b-form-checkbox
          switch
          size="sm"
          v-model="info.registroActivo"
          v-if="info.idNivel != null"
          >Activar / Inactivar</b-form-checkbox
        >
      </div>

      <br />
      <br />

      <div class="text-center">
        <b-button
          variant="primary"
          :disabled="
            isNaN(info.montoMinimo) ||
            isNaN(info.montoMaximo) ||
            info.montoMinimo == '' ||
            info.montoMaximo == '' ||
            info.montoMinimo == null ||
            info.montoMaximo == null ||
            info.idEmpleado == null
          "
          @click="guardar(info)"
          style="width: 100%"
          >Guardar</b-button
        >
      </div>

      <b-button class="mt-3" block @click="cerrarModal">Cerrar</b-button>
    </b-modal>
<!-- fin mondal    -->
  </div>
</template>
<script>
//components
import Header from "../../components/Header.vue";
import {TipoMovimientoService} from "@/apiServices/tipoMovimiento/TipoMovimientoService";
//import miniToastr from "mini-toastr"; //ES6

export default {
  name: "admAutorizaciones",
  components: {
    Header,
  },
  props: {
    msg: String,
    isDark: Boolean,
    "md-active-step": String,
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      filter: null,
      filterOn: [],
      isBusy: false,
      loading: false,
      cargandoTabla: false,
      arrayNiveles: [],
      fields: [
        { key: "idNivel", label: "No.", sortable: true },
        { key: "montoMinimo", label: "Monto mínimo", sortable: true },
        { key: "montoMaximo", label: "Monto máximo", sortable: true },
        { key: "nombreEmpleado", label: "Empleado", sortable: true },
        { key: "clinicas", label: "Clínicas", sortable: true },
        /*{ key: "tiposMovimiento", label: "Movimientos", sortable: true},*/
        { key: "registroActivo", label: "Activo / Inactivo", sortable: true },
        { key: "Detalle", label: "Detalle" },
      ],
      info: {
        idNivel: null,
        nombreEmpleado: null,
        idEmpleado: null,
        montoMinimo: null,
        montoMaximo: null,
        registroActivo: null,
        clinicas: null,
        Detalle: null,
        movimientos: [],
        tiposMovimiento: null
      },
      currentPage: 1,
      perPage: 15,
      totalRows: 1,
      loadingColaboradores: false,
      colaboradores: [],
      tiposMovimiento: [],
      allSelected: false,
      tipoMovimientoService: new TipoMovimientoService()
    };
  },
  async created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerNiveles();
    this.tiposMovimiento = await this.tipoMovimientoService.obtenerTiposMovimientoPorMovimiento();
  },
  methods: {
    seleccionarTodo(){
      this.allSelected = true;
      this.tiposMovimiento.forEach((item) => {
        item.tiposMovimiento.forEach((movimiento) => {
          this.info.movimientos.push(movimiento.value)
        });
      });
    },
    deseleccionarTodo(){
      this.allSelected = false;
      this.info.movimientos = [];
    },
    onFiltered(filteredItems) {
      this.isBusy = true;
      this.totalRows = filteredItems.length;
      setTimeout(() => (this.isBusy = false), 1000);
      this.currentPage = 1;
    },
    cerrarModal() {
      this.$bvModal.hide("modal-detalle");
      this.resetModal();
    },
    resetModal() {
      this.info = {
        idNivel: null,
        nombreEmpleado: null,
        idEmpleado: null,
        montoMinimo: null,
        montoMaximo: null,
        registroActivo: null,
        clinicas: null,
        Detalle: null,
        movimientos: [],
        tiposMovimientos: null,
      };
    },
    getColaboradores(searchTerm) {
      if (searchTerm === "") {
        this.loadingColaboradores = false;
        return false;
      }
      if (searchTerm != undefined && searchTerm.length > 10) {
        this.loadingColaboradores = true;
        var inputTxt = searchTerm.trim().toLowerCase().toUpperCase();
        this.$http
          .get(
            this.$api + "saldo/obtenerDatosEmpleado?nombreEmpleado=" + inputTxt,
            {}
          )
          .then((response) => {
            if (response.status === 200) {
              if (Array.isArray(response.data.data) == true) {
                this.colaboradores = response.data.data;
              }
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => (this.loadingColaboradores = false));
      }
    },
    guardar(datos) {
      datos.idUsuario = this.$localStorageService.getIdUsuario();
      var apiUrl = "guardar";
      if (datos.idNivel != null) {
        apiUrl = "actualizar";
      }

      // API

      this.$swal.fire({
        title: "¿Estás seguro de " + apiUrl + " el registro?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          this.loading = true;
          this.$http
            .post(this.$api + "saldo/nivel/guardar", datos)
            .then(() => {
              this.$swal({
                icon: "success",
                text: "Se guardó correctamente el nivel.",
              });
              this.obtenerNiveles();
            })
            .catch((error) => {
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: error,
              });
            })
            .finally(() => {
              this.loading = false;
            });
        },
      });
      //API

      this.$bvModal.hide("modal-detalle");
    },
    abrirDetalle(datos) {
      this.$bvModal.show("modal-detalle");
      this.info = datos;
    },
    abrirDetalleEmpty() {
      this.info.idNivel = null;
      this.info.nombreEmpleado = null;
      this.info.idEmpleado = null;
      this.info.montoMinimo = null;
      this.info.montoMaximo = null;
      this.info.registroActivo = null;
      this.info.clinicas = [];
      this.info.Detalle = null;
      this.info.tiposMovimiento = [];

      this.$bvModal.show("modal-detalle");
    },
    obtenerNiveles() {
      this.cargandoTabla = true;
      this.$http
        .get(this.$api + "saldo/obtenerNiveles")
        .then((response) => {
          this.cargandoTabla = false;
          if (response.status === 200) {
            if (Array.isArray(response.data.data) == true) {
              this.arrayNiveles = response.data.data.map((it) => {
                return {
                  idNivel: it.idNivel,
                  nombreEmpleado: it.nombreEmpleado,
                  idEmpleado: it.idEmpleado,
                  montoMinimo: it.montoMinimo,
                  montoMaximo: it.montoMaximo,
                  registroActivo: it.registroActivo,
                  clinicas: it.clinicas,
                  movimientos: it.movimientos,
                  Detalle: true,
                  tiposMovimiento: it.tiposMovimiento
                };
              });
              this.totalRows = this.arrayNiveles.length;
            }
          }
        })
        .catch((error) => {
          this.cargandoTabla = false;
          console.error(error);
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
    sinDecimales() {
      if (this.info.montoMinimo != undefined) {
        this.info.montoMinimo = parseInt(
          this.info.montoMinimo.toString().replace(/[^0-9]+/g, "")
        );
      }
      if (this.info.montoMaximo != undefined)
        this.info.montoMaximo = parseInt(
          this.info.montoMaximo.toString().replace(/[^0-9]+/g, "")
        );
    },
  },
  watch: {
    "info.montoMinimo"() {
      this.sinDecimales();
    },
    "info.montoMaximo"() {
      this.sinDecimales();
    },
  },
};
</script>
<style scoped>
.flxDivs {
  display: flex;
  flex-direction: row;
  padding-top: 20px;
  padding-bottom: 20px;
  justify-content: space-around;
}

.div90 {
  width: 95%;
  border: 2px solid #b9cde6;
  padding: 1%;
  border-radius: 12px;
}

.buttonGenerar {
  margin-top: 20px;
  margin-right: 10px;
  display: flex;
  justify-content: flex-end;
}

.flexDiv {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  text-align: left;
}

.item80 {
  width: 80%;
}

.item20 {
  width: 20%;
}
</style>
